import { Button } from '@heroui/react';
import React, { FC } from 'react';

import { ActionBlock } from '../ActionBlock';
import { Flex } from '../Flex';
import { ErrorDescription, ErrorTitle } from './ContentLoadError.styled';

interface ContentLoadErrorProps {
  onRefreshClicked?: () => void;
  message?: string | null;
}
export const ContentLoadError: FC<ContentLoadErrorProps> = ({ onRefreshClicked, message }) => (

  <ActionBlock>
    <Flex gap="10px" itemAlign="flex-start" justifyContent="center" direction="column">
      <ErrorTitle>Something went wrong while loading the content !</ErrorTitle>
      <ErrorDescription>
        {message || 'We couldn\'t load the content. Please try again.'}
      </ErrorDescription>
      {onRefreshClicked && (
      <Button
        onPress={onRefreshClicked}
        variant="solid"
        color="danger"
        type="submit"
        form="form-create-city"
        radius="sm"
      >
        Refresh
      </Button>
      ) }

    </Flex>
  </ActionBlock>

);
